export const getChapter = (state) => state.chapters;

export const getRelatedChapters = (state) => {
	const chapters = getChapter(state);
	if (!chapters && !chapters.allChapters) return null;
	return chapters;
};
